import { apiAxios } from 'src/util';

export const sendChatQuery = async (chatType, sessionId, question) => {
  const res = await apiAxios.post(`${chatType}-chat/query`, null, {
    params: {
      sessionId,
      question,
    },
  });
  return res.data;
};

export const getPipelineChatFields = async () => {
  const res = await apiAxios.get('pipeline-chat/fields');
  return res.data;
};

export const getPipelineFieldDefinition = async (fieldId) => {
  const res = await apiAxios.get('pipeline-chat/fields/definition', {
    params: { fieldId },
  });
  return res.data;
};

export const updatePipelineChatField = async (fieldId, roleList) => {
  const res = await apiAxios.put('pipeline-chat/fields', null, {
    params: {
      fieldId,
      roleList,
    },
  });
  return res.data;
};

export const deletePipelineChatField = async (fieldId) => {
  const res = await apiAxios.delete('pipeline-chat/fields', {
    params: { fieldId },
  });
  return res.data;
};
